import React from 'react';
const BreadContext = /*#__PURE__*/React.createContext({});
export default BreadContext;